import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store.js'

import Chain from '@/components/Chain/Chain.vue'
import Diff from '@/components/Diff/Diff.vue'
import ListGr from '@/components/ListGr.vue'
import GraphVis from '@/components/GraphVis.vue'
import Home from '@/components/Home.vue'
import HomeCustom from '@/components/HomeCustom.vue'
import Props from '@/components/Props/Props.vue'
import Login from '@/components/Login.vue'
import RegRequest from '@/components/RegRequest.vue'
import Admin from '@/components/Admin/Admin.vue'
import Actions from '@/components/Actions/Acts.vue'
import Triggers from '@/components/Triggers/Trgs.vue'
import NTasks from '@/components/NTasks/NTasks.vue'
import Orgs from '@/components/Orgs/Orgs.vue'
import Prods from '@/components/Prods/Prods.vue'
import SearchStart from '@/components/SearchStart.vue'
import LoginConnect from '@/components/LoginConnect.vue'
import YaLogin from '@/components/YaLogin.vue'
import YaAuthCallback from '@/components/YaAuthCallback.vue'
import GglLogin from '@/components/GglLogin.vue'
import GglAuthCallback from '@/components/GglAuthCallback.vue'
import KclLogin from '@/components/KclLogin.vue'
import KclAuthCallback from '@/components/KclAuthCallback.vue'
import KclBAuthCallback from '@/components/KclBAuthCallback.vue'

Vue.use(Router);

let AppHome = Home;
const router = new Router({

  routes: [
    {
      path: '/home',
      name: 'Home',
      component: AppHome
    },
    {
      path: '/newhome',
      name: 'HomeCustom',
      component: HomeCustom
    },
    {
      path: '/home/:projID',
      name: 'HomeProj',
      component: AppHome,
      props: true
    },
    {
      path: '/newhome/:projID',
      name: 'HomeCustomProj',
      component: HomeCustom,
      props: true
    },
    {
      path: '/search/:projID',
      name: 'Search',
      component: SearchStart,
      props: true
    },
    {
      path: '/home/:projID/:nodeID',
      name: 'HomeProjNode',
      component: AppHome,
      props: true
    },
    {
      path: '/newhome/:projID/:nodeID',
      name: 'HomeCustomProjNode',
      component: HomeCustom,
      props: true
    },
    {
      path: '/home/:projID/:nodeID/:fileID',
      name: 'HomeProjNodeFile',
      component: AppHome,
      props: true
    },
    {
      path: '/newhome/:projID/:nodeID/:fileID',
      name: 'HomeCustomProjNodeFile',
      component: HomeCustom,
      props: true
    },
    {
      path: '/diff',
      name: 'Diff',
      component: Diff
    },
    {
      path: '/chain',
      name: 'Chain',
      component: Chain
    },
    {
      path: '/listgr',
      name: 'ListGr',
      component: ListGr
    },
    {
      path: '/graphvis',
      name: 'GraphVis',
      component: GraphVis
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/orgs',
      name: 'Orgs',
      component: Orgs
    },
    {
      path: '/prods',
      name: 'Prods',
      component: Prods
    },
    {
      path: '/actions',
      name: 'Actions',
      component: Actions
    },
    {
      path: '/triggers',
      name: 'Triggers',
      component: Triggers
    },
    {
      path: '/ntasks',
      name: 'NTasks',
      component: NTasks
    },
    {
      path: '/props',
      name: 'Props',
      component: Props
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/regreq',
      name: 'RegReq',
      component: RegRequest
    },
    {
      path: '/yalogin',
      name: 'YaLogin',
      component: YaLogin
    },
    {
      path: '/yacallback',
      name: 'YaAuthCallback',
      component: YaAuthCallback
    },
    {
      path: '/ggllogin',
      name: 'GglLogin',
      component: GglLogin
    },
    {
      path: '/gglcallback',
      name: 'GglAuthCallback',
      component: GglAuthCallback
    },
    {
      path: '/kcllogin',
      name: 'KclLogin',
      component: KclLogin
    },
    {
      path: '/kclcallback',
      name: 'KclAuthCallback',
      component: KclAuthCallback
    },
    {
      path: '/kclbcallback',
      name: 'KclBAuthCallback',
      component: KclBAuthCallback
    },
    {
      path: '/loginconnect',
      name: 'LoginConnect',
      component: LoginConnect
    },
    {
        path: '*',
        redirect: '/home'
    }]
});

router.beforeResolve( async( to, from, next ) => 
{
    if( store.state.useNewGUI && to.path.substring( 0, 5 ) === '/home' )
    {
        let path = to.path.replace( '/home', '/newhome' );
        if( from.path !== path )
          router.push( path );
    }
    else
        next();
});

// router.beforeEach( async( to, from, next ) => 
// {
//    console.log( to, from, next );
//   if( store.state.useNewGUI && to.name === 'Home' )
//       next( { name: 'HomeCustom' } );
//   else
//       next();
// });

export default router;
